import React from "react";
import { Container, Col, Row, Input, FormGroup, Label, Button } from "reactstrap";

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Map from "../Component/Map";

const Contact = () => {
  return (
    <div id="investor" className="investor-container">
      <Header contact={true} />

      <Container className="contact-container">
        <Row className="row-content">
          <Col style={{ flexDirection: 'column' }} className="text-clm-contact" lg={6} md={12} sm={12}>
            <p className="title-contact">How Can we Help you?</p>
            <span>*<span>Indicates required field</span></span>

            <FormGroup>
              <Label className="title-label-contact">Name *</Label>
              <Row style={{ flexDirection: 'row', flex: 1 }}>
                <Input className="input-contact" placeholder="First" />
                <Input className="input-contact" placeholder="Last" />
              </Row>

            </FormGroup>

            <FormGroup>
              <Label className="title-label-contact">Email *</Label>
              <Row style={{ flexDirection: 'row', flex: 1 }}>
                <Input className="input-contact-2" />
              </Row>

            </FormGroup>

            <FormGroup>
              <Label className="title-label-contact">Subject *</Label>
              <Row style={{ flexDirection: 'row', flex: 1 }}>
                <Input className="input-contact-2" />
              </Row>

            </FormGroup>

            <FormGroup>
              <Label className="title-label-contact">Comment </Label>
              <Row style={{ flexDirection: 'row', flex: 1 }}>
                <Input type="textarea" className="input-contact-2" />
              </Row>

            </FormGroup>

            <Button className="contact-btn" color="primary">Submit</Button>

          </Col>
          <Col lg={6} md={12} sm={12}>
            <div className='contact-imgs'>
              <Map />
            </div>
          </Col>
        </Row>

      </Container>
      <Footer />
    </div>
  );
}

export default Contact;